export enum UserWorkspaceStatus {
  INVITED = "INVITED",
  DECLINED = "DECLINED",
  ACCEPTED = "ACCEPTED",
  LEFT = "LEFT",
  REMOVED = "REMOVED",
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
}
